import { useEffect } from "react"
import { Routes, Route, Navigate } from "react-router-dom"
import { App as AntdApp } from "antd"
import AppRouter from "./router"
import AppLayout from "./components/layout/AppLayout"
import { ChatProvider } from "./contexts/ChatContext"
import { NavProvider } from "./contexts/NavContext"
import { OptimizationProvider } from "./contexts/OptimizationContext"
import { AuthProvider } from "./contexts/AuthContext"
import { InitProvider } from "./contexts/InitContext"
import { EmbeddedAuthProvider, useEmbeddedAuth } from "./contexts/EmbeddedAuthContext"
import OAuth2Callback from "./pages/OAuth2Callback"
import ProtectedRoute from "./components/auth/ProtectedRoute"
import AuthModal from "./components/auth/embedded/AuthModal"
import useAppMessage from "./hooks/useAppMessage"
import useBaiduAnalytics from "./hooks/useBaiduAnalytics"
import { registerEmbeddedLoginTrigger } from "./services/api"

function AppContent() {
  useBaiduAnalytics();
  const { showLoginModal } = useEmbeddedAuth();

  // 注册登录弹窗触发器到 API 服务
  useEffect(() => {
    registerEmbeddedLoginTrigger(showLoginModal);
  }, [showLoginModal]);

  return (
    <>
      <Routes>
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="/callback" element={<OAuth2Callback />} />
        <Route path="/*" element={
          <ProtectedRoute>
            <AppLayout>
              <AppRouter />
            </AppLayout>
          </ProtectedRoute>
        } />
      </Routes>
      {/* 移除内嵌登录弹窗 <AuthModal /> */}
    </>
  );
}

function App() {
  const { message, contextHolder } = useAppMessage();
  window.message = message;
  
  // 调试日志：确认代码版本
  useEffect(() => {
    console.log('🚀 [Debug] App loaded - Version: 2026-01-06 Fix-Cross-Origin');
    console.log('🌍 [Debug] Environment:', {
      MODE: import.meta.env.MODE,
      BASE_URL: import.meta.env.BASE_URL,
      VITE_OAUTH_REDIRECT_URI: import.meta.env.VITE_OAUTH_REDIRECT_URI
    });
  }, []);

  return (
    <AntdApp>
      {contextHolder}
      <NavProvider>
        <ChatProvider>
          <OptimizationProvider>
            <AuthProvider>
              <EmbeddedAuthProvider>
                <InitProvider>
                  <AppContent />
                </InitProvider>
              </EmbeddedAuthProvider>
            </AuthProvider>
          </OptimizationProvider>
        </ChatProvider>
      </NavProvider>
    </AntdApp>
  )
}

export default App
